var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('SettingsSidebar'),_c('div',{class:_vm.$style.contentContainer},[_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }